import React from 'react';
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Alert from 'react-bootstrap/Alert'
import Logo from '../images/logo.png'



const Home = (props) => {
    return(
        <div className="home_container">     

            <div>

                <div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center">
                    <div className="col-md-5 p-lg-5 mx-auto my-5">
                        <h1 className="display-5 font-weight-normal">Admissions 2020-2021</h1>

                        <h1 className="display-5 font-weight-normal">Biswanath Commerce College</h1>
                        <a className="btn btn-lg btn-info btn-outline-light" href="/ArtsForm">Apply - Arts</a><span> </span>
                        <a className="btn btn-lg btn-info btn-outline-light" href="/CommerceForm">Apply - Commerce</a>
                    </div>
                </div>
            </div>

            <div className="container_fluid container col-lg-10 col-sm-12">
          
                
                <div className="after_navigation">
                    <div className="home_row_1 row p-0">

                        <Card style={{width:"100%",alignSelf:"auto"}} className="border-primary">
                            <Card.Header className="bg-primary text-center text-light" as="h3">Read the Instructions below carefully! <span className="text-muted small">*</span></Card.Header>                   
                        </Card>

                        <div style={{width:"100%",alignSelf:"auto"}}  className="special-card">
                            <Alert variant="danger" className="font-weight-bold text-center ">Last date of form Fillup is - (xx/xx/xxxx)</Alert>
                            <Card.Body className="text-dark font-weight-bold">
                                <Card.Title as="h4" >
                                <strong> Step 1:</strong> Fill up the form carefully and accurately. Make sure to correctly enter your subject choices and previous academic records.
                                    <br/>
                                <strong> Step 2:</strong> Upon successful submission of the form, you will recieve your application number. Carefully note down this number. You will be required to provide it in the future. 
                                    <br/>
                               <strong> Note:</strong> It should be mentioned that the aplication number will <strong>NOT</strong> be sent to you via sms or email or any other method. It is your responsibility to carefully note down or keep a record of it when u recieve it.
                                    <br/>
                                <strong> Step 3:</strong> Upon completion of the form and  recieving the application number, you can make the payment of the admission fees through the method of UPI(googlepay, paytm, phone-pe, Amazon pay, SBI YONO or any other BHIM UPI provider) to the account of the college. 
                                    <br/> 
                                <strong> Note:</strong> You <strong>MUST</strong> mention your name and the application number while making the payment. Please remember that this is very important. If you donot mention the application number while payment it will be difficult to verify the authenticity of the payment.      
    
                                </Card.Title>
                                <Card.Title as="h4">
                                    
                                </Card.Title>
                                <div className="text-center fluid">
                                  <Button className="mx-auto align-center btn-lg" href="/ArtsForm" variant="primary">Apply - Arts</Button><span> </span>
                                  <Button className="mx-auto align-center btn-lg" href="/CommerceForm" variant="primary">Apply - Commerce</Button>
                                </div>
                            </Card.Body>    
                        </div>

                        
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Home;